import React from "react"
import { useDispatch } from "react-redux"
import { goBack } from "react-router-redux"
import SettingsIcon from "@mui/icons-material/Settings"

import GenericTopBarHeader from "../../../components/GenericTopBarHeader"
import PageHeaderTitle from "../../../components/PageHeaderTitle"
import { COLORS,  } from "../../../utils"

const EnterprisesHeader = ({ subtitle }) => {
  const dispatch = useDispatch()
 
  const handleBack = () => dispatch(goBack())

  return (
      <GenericTopBarHeader
        onBack={handleBack}
        title={
          <PageHeaderTitle
            title="Paramètres des entreprises"
            icon={<SettingsIcon sx={{ color: COLORS.PRIMARY_COLOR }} />}
            color={COLORS.PRIMARY_COLOR}
            subtitle={subtitle}
            separator="/"
          />
        }
      />
  )
}

export default EnterprisesHeader
